import {ExternalReview} from '@app/models/reviews';
import {StarRating} from '@app/components';
import GoogleIcon from '@app/assets/icons/Google.svg?react';
import YelpIcon from '@app/assets/icons/integrations/yelp.svg?react';
import {IntegrationType} from "@app/utils/consts.tsx";

interface DashboardReviewItemProps {
  review: ExternalReview | any;
  onClick?: () => void;
}

export const DashboardReviewItem = ({ review, onClick }: DashboardReviewItemProps) => {
  const getPlatformIcon = () => {
    if (review.sourceType === IntegrationType.YELP) {
      return (
        <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center">
          <YelpIcon className="w-5 h-5" />
        </div>
      );
    } else {
      // Default to Google for google or unknown platforms
      return (
        <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center">
          <GoogleIcon className="w-5 h-5" />
        </div>
      );
    }
  };

  const getTimeAgo = (date?: any) => {
    if (!date) return '';

    const now = new Date();
    const reviewDate = new Date(date);
    const diffInMinutes = Math.floor((now.getTime() - reviewDate.getTime()) / (1000 * 60));
    
    if (diffInMinutes < 60) {
      return `${diffInMinutes} mins ago`;
    } else if (diffInMinutes < 1440) {
      const hours = Math.floor(diffInMinutes / 60);
      return `${hours} hour${hours > 1 ? 's' : ''} ago`;
    } else {
      const days = Math.floor(diffInMinutes / 1440);
      return `${days} day${days > 1 ? 's' : ''} ago`;
    }
  };

  return (
    <div 
      className="p-3 sm:p-4 border-b border-gray-100 hover:bg-gray-50 transition-colors cursor-pointer"
      onClick={onClick}
    >
      <div className="flex items-start gap-2 sm:gap-3">
        <div className="flex-shrink-0">
          {getPlatformIcon()}
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-2 gap-2">
            <div className="min-w-0">
              <p className="text-sm font-medium text-gray-900 truncate">
                {review.reviewerName}
              </p>
              <p className="text-xs text-gray-500">
                Left a review {getTimeAgo(review.createTime)}
              </p>
            </div>
          </div>

          <div className="flex items-center gap-2 mb-2">
            <StarRating rating={review.rating ?? 0} size={{ width: 16, height: 16 }} />
          </div>

          <p className="text-sm text-gray-700 line-clamp-3">
            {review.body}
          </p>

          {/*{review.photos && review.photos.length > 0 && (*/}
          {/*  <div className="flex gap-2 mt-3">*/}
          {/*    {review.photos.slice(0, 3).map((_, index) => (*/}
          {/*      <div key={index} className="w-16 h-16 bg-gray-200 rounded-lg flex items-center justify-center">*/}
          {/*        <span className="text-xs text-gray-500">IMG</span>*/}
          {/*      </div>*/}
          {/*    ))}*/}
          {/*  </div>*/}
          {/*)}*/}

          {/* Review Reply Section */}
          {review.replyBody &&  (
            <div className="mt-3 pt-3 border-t border-gray-100">
              <div className="mb-2">
                <p className="text-xs text-gray-500">
                  Replied {review?.updateTime ? getTimeAgo(review?.updateTime) : ''}
                </p>
              </div>
              <div className="bg-gray-50 rounded-lg p-3">
                <p className="text-sm text-gray-700">
                  {review.replyBody}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
